import {Pipe, PipeTransform} from '@angular/core';
import {IncidentType} from "@services";

@Pipe({
    name: 'incidentType',
    standalone: true
})
export class IncidentTypePipe implements PipeTransform {
    transform(value: IncidentType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case IncidentType.CaughtInUnderBetween : return "Caught in / under/ between";
            case IncidentType.FallOnSameLevel : return "Fall on same level";
            case IncidentType.MaterialsDropped : return "Materials dropped";
            case IncidentType.ChemicalExposure : return "Chemical exposure";
            case IncidentType.EquipmentFailure : return "Equipment Failure";
            case IncidentType.ContactWithTemperatureExtremes : return "Contact with temperature extremes";
            case IncidentType.StruckBy : return "Struck by";
            case IncidentType.PropertyMissing : return "Property missing";
            case IncidentType.OverExertion : return "Over-exertion";
            case IncidentType.RubbedAbraded : return "Rubbed / Abraded";
            case IncidentType.ContractorDamage : return "Contractor Damage";
            case IncidentType.FallFromElevation : return "Fall from elevation";
            case IncidentType.StruckAgainst : return "Struck against";
            case IncidentType.MaterialsPunctured : return "Materials punctured";
            default: return value;
        }
    }
}